import React from 'react';
import { Row, Col, FormGroup, Label, Input } from 'reactstrap';
import { FormikProps } from 'formik';
import { ShopFormValues } from 'components/Types/Tenant/shop.type';

interface Props {
  formik: FormikProps<ShopFormValues>;
}

const MediaTab: React.FC<Props> = ({ formik }) => {
  return (
    <Row>
      <Col md={6}>
        <FormGroup>
          <Label>Logo URL</Label>
          <Input
            type="url"
            name="logoUrl"
            value={formik.values.logoUrl}
            onChange={formik.handleChange}
            invalid={!!(formik.touched.logoUrl && formik.errors.logoUrl)}
          />
          {formik.touched.logoUrl && formik.errors.logoUrl && (
            <div className="invalid-feedback">{formik.errors.logoUrl}</div>
          )}
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup>
          <Label>Cover Image URL</Label>
          <Input
            type="url"
            name="coverImageUrl"
            value={formik.values.coverImageUrl}
            onChange={formik.handleChange}
            invalid={!!(formik.touched.coverImageUrl && formik.errors.coverImageUrl)}
          />
          {formik.touched.coverImageUrl && formik.errors.coverImageUrl && (
            <div className="invalid-feedback">{formik.errors.coverImageUrl}</div>
          )}
        </FormGroup>
      </Col>
    </Row>
  );
};

export default MediaTab;
